import React from "react";
import { useOtpStyles } from "./otpStyles";

export function OTPInput({ value, onChange }) {
  const classes = useOtpStyles();

  const handleChange = (e, index) => {
    const val = e.target.value.replace(/\D/g, ""); // solo números
    if (!val) return;

    const newValue = value.split("");
    newValue[index] = val[0];
    onChange(newValue.join(""));

    // mover foco al siguiente input
    if (index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newValue = value.split("");
      newValue[index] = "";
      onChange(newValue.join(""));

      if (index > 0) {
        document.getElementById(`otp-${index - 1}`).focus();
      }
    }
  };

  return (
    <div className={classes.otpContainer}>
      {Array.from({ length: 6 }).map((_, index) => (
        <input
          key={index}
          id={`otp-${index}`}
          className={classes.otpInput}
          type="text"
          maxLength="1"
          value={value[index] || ""}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
        />
      ))}
    </div>
  );
}
